import { render, staticRenderFns } from "./MenuLinksGlobalStyle.vue?vue&type=template&id=3109fa2e"
import script from "./MenuLinksGlobalStyle.vue?vue&type=script&lang=js"
export * from "./MenuLinksGlobalStyle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports